import { clearSession } from '../_helpers/session';
import { apiClient } from './api.client';

export const userService = {
  login,
  logout,
  register,
  getAll,
  getById,
  update,
  delete: _delete,
  getUser,
  getBusinessProfile,
  updateBusinessProfile,
  CandidateProfile,
  CandidateScholarship,
  CandidateLanguages,
  CandidateJobs,
  CandidateJobProfile,
  CandidateExpectedJobs,
  recoverPassword,
  recover,
};

function recoverPassword(user) {
  return apiClient.post('/auth/reset/', user);
}

function recover(user) {
  return apiClient.post('/auth/password-reset/', user);
}

function login(user) {
  return apiClient.post('/auth/login/', user);
}

function getUser() {
  return apiClient.get('/api/v1/me');
}

function logout() {
  clearSession();

  return apiClient.post('/auth/logout/', {});
}

function getAll() {
  return apiClient.get('/users');
}

function getById(id) {
  return apiClient.get(`/users/${id}`);
}

function register(user) {
  return apiClient.post('/auth/register/', user);
}

function update(user) {
  return apiClient.put(`/users/${user.id}`, user, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

function _delete(id) {
  return apiClient.delete(`/users/${id}`);
}

function getBusinessProfile() {
  return apiClient.get('/api/user/business/profile/');
}

function updateBusinessProfile(data) {
  return apiClient.put('/api/user/business/profile/', data);
}

function CandidateJobProfile() {
  return apiClient.get('/api/user/candidate/job-profile/');
}

function CandidateProfile() {
  return apiClient.get('/api/user/candidate/profile/');
}

function CandidateScholarship() {
  return apiClient.get('/api/user/candidate/scholarship/');
}

function CandidateLanguages() {
  return apiClient.get('/api/user/candidate/languages/');
}

function CandidateJobs() {
  return apiClient.get('/api/user/candidate/jobs/');
}

function CandidateExpectedJobs() {
  return apiClient.get('/api/user/candidate/expected-job/');
}
